

export class BetterError extends Error {
  status: number;
  data: any;
  originalError?: Error;

  constructor(
    message: string,
    status: number,
    data?: any,
    originalError?: Error,
  ) {
    super(message);
    this.status = status;
    this.data = data;
    this.originalError = originalError;
  }

  setData(newData: any) {
    this.data = newData;
  }

  extendData(newData: any) {
    this.data = {
      ...this.data,
      ...newData,
    };
  }

  toJSON() {
    return {
      message: this.message,
      status: this.status,
      data: this.data,
    };
  }
}

